import React from "react";
import Utils from "@/utils/Default/Utils";
import {CUSTOMER_AREA_PAGE, SEARCH_PAGE} from "@/utils/constants";

const BreadCrumbElement = ({ id, label, url }) => {
    return (
        <span className="breadcrumb-item" key={id}>
      {url ? (
          <a href={url} title={label}>
              <span>{label}</span>
          </a>
      ) : (
          <span>{label}</span>
      )}
    </span>
    );
};
const ProductListBreadCrumb = ({
                                   levelsNavigation,
                                   parentsCategories,
                                   context,
                               }) => {
    let index = 1;
    let parentsSparkowShopLabel = ["Boutiques", "Marques", "Themes"];
    return levelsNavigation.map((levelNavigation, i) => {
        if (i + 1 === levelsNavigation.length) {
            index++;
            return (
                <span key={levelNavigation.id}>
          <strong>{levelNavigation.label}</strong>
                    {context !== CUSTOMER_AREA_PAGE && context !== SEARCH_PAGE && (
                        <meta content={index} />
                    )}
        </span>
            );
        } else if (
            parentsCategories &&
            parentsCategories[i] &&
            parentsCategories[i].label
        ) {
            let item = parentsCategories[i];
            index++;
            if (context === CUSTOMER_AREA_PAGE) {
                return (
                    <span key={item.id}>
            <a href={item.url} title={item.label}>
              <span>{item.label}</span>
            </a>
          </span>
                );
            } else if (parentsSparkowShopLabel.indexOf(item.label) === -1) {
                return (
                    <span key={item.id}>
            <a
                href={Utils.getMetaInfosValueByCode("SeoUrl", item.metaInfos)}
                title={item.label}
            >
              <span>{item.label}</span>
            </a>
            <meta content={index} />
          </span>
                );
            } else {
                return <BreadCrumbElement id={item.id} label={item.label} />;
            }
        } else {
            if (levelNavigation && levelNavigation.label) {
                return (
                    <BreadCrumbElement
                        id={levelNavigation.id}
                        label={levelNavigation.label}
                        url={levelNavigation.url ?? ""}
                    />
                );
            }
            return null;
        }
    });
};

const FirstLevel = ({ context }) => {
    if (context === CUSTOMER_AREA_PAGE) {
        return (
            <a href="/" title="Mon compte">
                <span>Mon compte</span>
            </a>
        );
    } else if (context === SEARCH_PAGE) {
        return (
            <a href="/" title="Accueil BUT">
                <span>Accueil BUT</span>
            </a>
        );
    } else {
        return (
            <>
                <a href="/" title="Accueil BUT">
                    <span>Accueil BUT</span>
                </a>
                <meta content="1" />
            </>
        );
    }
};

export const Breadcrumb = (props) => {
    return (
        <div
            className={`breadcrumb ${
                props.context === CUSTOMER_AREA_PAGE ? "customerArea" : ""
            }`}
        >
            <div className="levels">
                <span>{FirstLevel(props)}</span>
                {props.context === SEARCH_PAGE ? (
                    <span>
            <strong>Résultats pour "{props.keyWord}"</strong>
          </span>
                ) : (
                    <ProductListBreadCrumb
                        levelsNavigation={props.levelsNavigation}
                        parentsCategories={props.parentsCategories}
                        context={props.context}
                    />
                )}
            </div>
        </div>
    );
};
